import React from 'react';
import { useSearchParams } from 'next/navigation';
import BaseLayout from '../layouts/BaseLayout.jsx';
import LoginC from '../components/Login.jsx';

function LoginPage() {
  // Get the 'next' parameter from URL using Next.js hooks
  const searchParams = useSearchParams();
  const nextUrl = searchParams.get('next') || '/'; // Default to "/" if 'next' isn't provided

  return (
    <BaseLayout
      title="Login to Your Account"
      description="Explore a great collection of icons"
      showHeader={false}
    >
      <div className="flex items-center justify-center h-full">
        {/* Removed flex-grow and py-10 */}
        <LoginC nextUrl={nextUrl} />
      </div>
    </BaseLayout>
  );
}

export default LoginPage;